import { render } from "./Faq.vue?vue&type=template&id=6e4f0475&scoped=true&class=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=6e4f0475&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4f0475"]])

export default __exports__